var map = {
	"./bank-transfer.svg": 1767,
	"./betnearn-ico.svg": 1768,
	"./birthday-bonus-ico.svg": 1769,
	"./birthday.svg": 1770,
	"./bonus-code-ico.svg": 1771,
	"./bonus-ico.svg": 1772,
	"./bonus-received-ico.svg": 1773,
	"./bonus.svg": 1774,
	"./business-account-upgrade-ico.svg": 1775,
	"./check-in-daily-ico.svg": 1776,
	"./checked.svg": 1777,
	"./cloud-pointer.svg": 1778,
	"./crypto.svg": 1779,
	"./daily-bonus-ico.svg": 1780,
	"./daily-limit.svg": 1781,
	"./e-wallet.svg": 1782,
	"./earn-x33-coin-ico.svg": 1783,
	"./email.svg": 1784,
	"./facebook.svg": 1785,
	"./feedback.svg": 1786,
	"./first-bet-ico.svg": 1787,
	"./games-rebate-ico.svg": 1788,
	"./info.svg": 1789,
	"./instagram.svg": 1790,
	"./live-casino-rebate-ico.svg": 1791,
	"./lucky-spin-ico.svg": 1792,
	"./messenger.svg": 1793,
	"./monthly-cash.svg": 1794,
	"./msg-activity.svg": 1795,
	"./msg-ann.svg": 1796,
	"./msg-notice.svg": 1797,
	"./new-icon.svg": 1798,
	"./people-ico.svg": 1799,
	"./quick-pay.svg": 1800,
	"./rescue-bonus-ico.svg": 1801,
	"./rescue-lc-ico.svg": 1802,
	"./rescue-slots-ico.svg": 1803,
	"./return.svg": 1804,
	"./sc-bc-active-ico.svg": 1805,
	"./sc-bc-ico.svg": 1806,
	"./sc-bi-active-ico.svg": 1807,
	"./sc-bi-ico.svg": 1808,
	"./sc-mail-active-ico.svg": 1809,
	"./sc-mail-ico.svg": 1810,
	"./sc-mp-active-ico.svg": 1811,
	"./sc-mp-ico.svg": 1812,
	"./sc-pin-active-ico.svg": 1813,
	"./sc-pin-ico.svg": 1814,
	"./slots-rebate-ico.svg": 1815,
	"./sports-rebate-ico.svg": 1816,
	"./telegram.svg": 1817,
	"./twitter.svg": 1818,
	"./vip-up-level-ico.svg": 1819,
	"./vip-weekly-bonus.svg": 1820,
	"./wallet-balance-interest-ico.svg": 1821,
	"./wallet-ico.svg": 1822,
	"./weekly-tournament-ico.svg": 1823,
	"./welcome-bonus-ico.svg": 1824,
	"./whatsapp.svg": 1825,
	"./withdrawal.svg": 1826,
	"./x33-coin.svg": 1827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 378;